import React from 'react';
import Icon from '../../../components/AppIcon';

const RequiredDocuments = ({ documents }) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-3" data-aos="fade-right">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="FileText" size={20} color="var(--color-primary)" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg md:text-xl font-heading font-bold text-foreground">
            Dokumen yang Diperlukan
          </h3>
          <p className="text-sm text-muted-foreground">
            Siapkan dokumen berikut untuk proses kredit
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4"data-aos="fade-left">
        {documents?.map((doc, index) => (
          <div
            key={index}
            className="p-4 bg-card border border-border rounded-lg hover:border-primary hover:shadow-card-hover transition-all duration-300"
          >
            <div className="flex items-start space-x-3">
              <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name={doc?.icon} size={20} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-heading font-semibold text-sm text-foreground mb-1">
                  {doc?.title}
                </p>
                <p className="text-xs text-muted-foreground">
                  {doc?.description}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="p-4 bg-muted rounded-lg" data-aos="fade-right">
        <div className="flex items-start space-x-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div className="flex-1">
            <p className="text-sm font-heading font-semibold text-foreground mb-2">
              Tips Pengajuan Kredit
            </p>
            <ul className="text-sm text-muted-foreground space-y-1">
              <li>• Pastikan semua dokumen asli dan fotokopi tersedia</li>
              <li>• Dokumen harus masih berlaku dan tidak kadaluarsa</li>
              <li>• Fotokopi harus jelas dan mudah dibaca</li>
              <li>• Siapkan dokumen tambahan jika diperlukan</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequiredDocuments;